import { FaShieldAlt, FaLightbulb, FaCog, FaThermometerHalf, FaCamera, FaMobileAlt } from 'react-icons/fa';

export const servicesData = [
  {
    id: 'security',
    icon: FaShieldAlt,
    titleKey: 'services.service1.title',
    descKey: 'services.service1.description',
    featuresKeys: [
      'services.service1.feature1',
      'services.service1.feature2',
      'services.service1.feature3',
      'services.service1.feature4',
    ],
    image: 'https://images.unsplash.com/photo-1558002038-1055907df827?crop=entropy&cs=srgb&fm=webp&w=800&q=75&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGhvbWV8ZW58MHx8fHwxNzcyNjMzNzkzfDA&ixlib=rb-4.1.0',
    color: '#00d4ff',
  },
  {
    id: 'lighting',
    icon: FaLightbulb,
    titleKey: 'services.service2.title',
    descKey: 'services.service2.description',
    featuresKeys: [
      'services.service2.feature1',
      'services.service2.feature2',
      'services.service2.feature3',
      'services.service2.feature4',
    ],
    image: 'https://images.unsplash.com/photo-1614696131965-cc559b1ecad1?crop=entropy&cs=srgb&fm=webp&w=800&q=75&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxzbWFydCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MjYzMzgxM3ww&ixlib=rb-4.1.0',
    color: '#ffaa00',
  },
  {
    id: 'automation',
    icon: FaCog,
    titleKey: 'services.service3.title',
    descKey: 'services.service3.description',
    featuresKeys: [
      'services.service3.feature1',
      'services.service3.feature2',
      'services.service3.feature3',
      'services.service3.feature4',
    ],
    image: 'https://images.unsplash.com/photo-1608377205619-03a0b4c4e270?crop=entropy&cs=srgb&fm=webp&w=800&q=75&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxob21lJTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3NzI2MzM3OTd8MA&ixlib=rb-4.1.0',
    color: '#00ffcc',
  },
  {
    id: 'climate',
    icon: FaThermometerHalf,
    titleKey: 'services.service4.title',
    descKey: 'services.service4.description',
    featuresKeys: [
      'services.service4.feature1',
      'services.service4.feature2',
      'services.service4.feature3',
      'services.service4.feature4',
    ],
    image: 'https://images.unsplash.com/photo-1519558260268-cde7e03a0152?crop=entropy&cs=srgb&fm=webp&w=800&q=75&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxzbWFydCUyMGhvbWV8ZW58MHx8fHwxNzcyNjMzNzkzfDA&ixlib=rb-4.1.0',
    color: '#ff6b6b',
  },
  {
    id: 'cctv',
    icon: FaCamera,
    titleKey: 'services.service5.title',
    descKey: 'services.service5.description',
    featuresKeys: [
      'services.service5.feature1',
      'services.service5.feature2',
      'services.service5.feature3',
      'services.service5.feature4',
    ],
    image: 'https://images.unsplash.com/photo-1706774609219-56c61f8b3c51?crop=entropy&cs=srgb&fm=webp&w=800&q=75&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxzbWFydCUyMGhvbWV8ZW58MHx8fHwxNzcyNjMzNzkzfDA&ixlib=rb-4.1.0',
    color: '#9b59b6',
  },
  {
    id: 'app',
    icon: FaMobileAlt,
    titleKey: 'services.service6.title',
    descKey: 'services.service6.description',
    featuresKeys: [
      'services.service6.feature1',
      'services.service6.feature2',
      'services.service6.feature3',
      'services.service6.feature4',
    ],
    image: 'https://images.unsplash.com/photo-1717323181080-334e21c2dde5?crop=entropy&cs=srgb&fm=webp&w=800&q=75&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxJb1QlMjBkZXZpY2VzfGVufDB8fHx8MTc3MjYzMzgwOXww&ixlib=rb-4.1.0',
    color: '#3498db',
  },
];
